const height = 1250;
const width = 2350;

const cw = width / 20;
const ch = height / 20;

// Please always use width:height ratio 9:14
const ratioIndex = 19
const CARD_WIDTH = 9 * ratioIndex
const CARD_HEIGHT = 14 * ratioIndex

const backCardRatioIndex = 10
const BACK_CARD_WIDTH = 9 * backCardRatioIndex
const BACK_CARD_HEIGHT = 14 * backCardRatioIndex

const centerCardRatioIndex = 18
const CENTER_CARD_WIDTH = 9 * centerCardRatioIndex
const CENTER_CARD_HEIGHT = 14 * centerCardRatioIndex

const centerMultiCardRatioIndex = 12
const CENTER_MULTI_CARD_WIDTH = 9 * centerMultiCardRatioIndex
const CENTER_MULTI_CARD_HEIGHT = 14 * centerMultiCardRatioIndex

const seatLayout = {
    2: [
        // { x: cw * 10, y: ch * 4 },
        { x: cw * 10, y: ch * 2.75 },
        // { x: cw * 12.25, y: ch * 16.5 }
        { x: cw * 10, y: ch * 18 }
    ],
    4: [
        { x: cw * 10, y: ch * 2.75 },
        { x: cw * 2.2, y: ch * 10 },
        { x: cw * 10, y: ch * 18 },
        { x: cw * 17, y: ch * 10 },
    ],
    6: [
        { x: cw * 10, y: ch * 2.75 },
        { x: cw * 6, y: ch * 5.75 },
        { x: cw * 5.5, y: ch * 11.5 },
        { x: cw * 10, y: ch * 18 },
        { x: cw * 14.5, y: ch * 11.5 },
        { x: cw * 13.75, y: ch * 5.75 },
    ]
}

const seatPointsLayout = {
    2: [
        // { x: cw * 10, y: ch * 4 },
        { x: cw * 8.4, y: ch * 5.75 },
        { x: cw * 12.65, y: ch * 15.75 }
    ],
    4: [
        { x: cw * 8.4, y: ch * 5.75 },
        { x: cw * 2.2, y: ch * 10 },
        { x: cw * 12.65, y: ch * 15.75 },
        { x: cw * 17, y: ch * 10 },
    ],
    6: [
        { x: cw * 8.4, y: ch * 5.75 },
        { x: cw * 3.3, y: ch * 6 },
        { x: cw * 3.3, y: ch * 15 },
        { x: cw * 12.65, y: ch * 15.75 },
        { x: cw * 16, y: ch * 15 },
        { x: cw * 16, y: ch * 6 },
    ]
}

const cardsLayout = {
    2: [
        // { x: cw * 10.2, y: ch * 4.75 },
        // { x: cw * 10.2, y: ch * 7.25 },
        // { x: cw * 10, y: ch * 17.5 },
        { x: cw * 9.65, y: ch * 6.25 },
        { x: cw * 9.3, y: ch * 17.5 },
    ],
    4: [
        { x: cw * 9.65, y: ch * 6.25 },
        { x: cw * 2.4, y: ch * 10.7 },
        { x: cw * 9.3, y: ch * 17.5 },
        { x: cw * 17.2, y: ch * 10.7 },
    ],
    6: [
        { x: cw * 9.65, y: ch * 6.25 },
        { x: cw * 6, y: ch * 7.5 },
        { x: cw * 6, y: ch * 12 },
        { x: cw * 9.3, y: ch * 17.5 },
        { x: cw * 13.25, y: ch * 12 },
        { x: cw * 13.25, y: ch * 7.5 },
    ]
}

const centerCardsLayOut = {
    2: [
        { x: cw * 9.5, y: ch * 12.75 },
        { x: (cw * 9.5) + CENTER_CARD_WIDTH, y: ch * 12.75 }
    ],
    4: [
        { x: cw * 8.8, y: ch * 9.5 },
        { x: (cw * 8.8) + CENTER_CARD_WIDTH, y: ch * 9.5 },
        { x: (cw * 8.8) + (CENTER_CARD_WIDTH * 2), y: ch * 9.5 },
        { x: (cw * 8.8) + (CENTER_CARD_WIDTH * 3), y: ch * 9.5 },
    ],
    6: [
        { x: cw * 7, y: ch * 9 },
        { x: (cw * 7) + (CENTER_CARD_WIDTH * 1), y: ch * 9 },
        { x: (cw * 7) + (CENTER_CARD_WIDTH * 2), y: ch * 9 },
        { x: (cw * 7) + (CENTER_CARD_WIDTH * 3), y: ch * 9 },
        { x: (cw * 7) + (CENTER_CARD_WIDTH * 4), y: ch * 9 },
        { x: (cw * 7) + (CENTER_CARD_WIDTH * 5), y: ch * 9 },
    ]
}

const stackCenterCardsLayout = {
    2: [
        { x: cw * 9.25, y: ch * 11.25 },
        // { x: cw * 9.5, y: (ch * 11) + (CENTER_CARD_HEIGHT * 0.3) },
        { x: cw * 9.25, y: (ch * 11.25) + (CENTER_CARD_HEIGHT * 0.3) },
    ],
    4: [
        { x: cw * 9.25, y: ch * 11.25 },
        { x: (cw * 10) - (CENTER_CARD_WIDTH * 0.5), y: (ch * 10.3) + (CENTER_CARD_HEIGHT * 0.3) },
        { x: cw * 10, y: (ch * 10.3) + (CENTER_CARD_HEIGHT * 0.6) },
        { x: (cw * 10) + (CENTER_CARD_WIDTH * 0.5), y: (ch * 10.3) + (CENTER_CARD_HEIGHT * 0.3) },
    ],
    6: [
        { x: cw * 9.625, y: ch * 9 },
        { x: cw * 7.75, y: ch * 9.25 },
        { x: cw * 7.75, y: ch * 12.5 },
        { x: cw * 9.625, y: ch * 13 },
        { x: cw * 11.5, y: ch * 12.5 },
        { x: cw * 11.5, y: ch * 9.25 },
    ]
}

const dealerLayout = {
    2: [
        // { x: cw * 10.9, y: ch * 4.75 },
        { x: cw * 9, y: ch * 2 },
        { x: cw * 12, y: ch * 17.5 }
    ],
    4: [
        { x: cw * 9, y: ch * 2 },
        { x: cw * 3, y: ch * 10.75 },
        { x: cw * 12, y: ch * 17.5 },
        { x: cw * 16.8, y: ch * 10.75 },
    ],
    6: [
        { x: cw * 9, y: ch * 2 },
        { x: cw * 4.1, y: ch * 6.75 },
        { x: cw * 4.1, y: ch * 15.75 },
        { x: cw * 12, y: ch * 17.5 },
        { x: cw * 15.7, y: ch * 15.75 },
        { x: cw * 15.7, y: ch * 6.75 },
    ]
}

const timerPositionLayout = {
    2: [
        // { x: cw * 9.85, y: ch * 6.3 },
        { x: cw * 7.75, y: ch * 4.75 },
        { x: cw * 12, y: ch * 16.5 },
    ],
    4: [
        { x: cw * 7.75, y: ch * 4.75 },
        { x: cw * 2.05, y: ch * 12.3 },
        { x: cw * 12, y: ch * 16.5 },
        { x: cw * 16.85, y: ch * 12.3 },
    ],
    6: [
        { x: cw * 7.75, y: ch * 4.75 },
        { x: cw * 3.15, y: ch * 8.2 },
        { x: cw * 3.15, y: ch * 17.3 },
        { x: cw * 12, y: ch * 16.5 },
        { x: cw * 15.9, y: ch * 17.2 },
        { x: cw * 15.9, y: ch * 8.3 },
    ]
}

const digitalTimerPositionLayout = {
    2: [
        // { x: cw * 9.85, y: ch * 6.3 },
        { x: cw * 8.25, y: ch * 3.75 },
        { x: cw * 12.4, y: ch * 17 },
    ],
    4: [
        { x: cw * 8.25, y: ch * 3.75 },
        { x: cw * 2.05, y: ch * 12.3 },
        { x: cw * 12.4, y: ch * 17 },
        { x: cw * 16.85, y: ch * 12.3 },
    ],
    6: [
        { x: cw * 8.25, y: ch * 3.75 },
        { x: cw * 3.15, y: ch * 8.2 },
        { x: cw * 3.15, y: ch * 17.3 },
        { x: cw * 12.4, y: ch * 17 },
        { x: cw * 15.9, y: ch * 17.2 },
        { x: cw * 15.9, y: ch * 8.3 },
    ]
}


const landScapeTrucoLayout = {
    seatLayout: seatLayout,
    seatPointsLayout: seatPointsLayout,
    cardLayout: cardsLayout,
    centerCardLayout: centerCardsLayOut,
    stackCenterCardsLayout: stackCenterCardsLayout,
    dealerIconLayout: dealerLayout,
    timerPositionLayout: timerPositionLayout,
    digitalTimerPositionLayout: digitalTimerPositionLayout,
    cardWidth: CARD_WIDTH,
    cardHeight: CARD_HEIGHT,
    backCardWidth: BACK_CARD_WIDTH,
    backCardHeight: BACK_CARD_HEIGHT,
    centerCardWidth: CENTER_CARD_WIDTH,
    centerCardHeight: CENTER_CARD_HEIGHT,
    centerMultiCardWidth: CENTER_MULTI_CARD_WIDTH,
    centerMultiCardHeight: CENTER_MULTI_CARD_HEIGHT,
    heightGap: CARD_HEIGHT * 0.057,
    backCardHeightGap: BACK_CARD_HEIGHT * 0.057,
    centerCardHeightGap: CENTER_CARD_HEIGHT * 0.057,
    centerCardWidthGap: CENTER_CARD_WIDTH * 0.75,
    centerMultiCardHeightGap: CENTER_MULTI_CARD_HEIGHT * 0.057,
    centerMultiCardWidthGap: CENTER_MULTI_CARD_WIDTH * 0.3,
    widthGap: CARD_WIDTH * 0.75,
    backCardWidthGap: BACK_CARD_WIDTH * 0.75,
    rotation: CARD_WIDTH * (15 / 180),
    backCardRatioIndex: backCardRatioIndex,
    ratioIndex: ratioIndex,
}

export { seatLayout, centerCardsLayOut, cardsLayout, dealerLayout, landScapeTrucoLayout }